export const MetaTagEndpoints = {
  linkPreview: () => '/api/v1/scraper'
}
